import React from 'react';
import { Helmet } from 'react-helmet';

const HreflangTags = ({ links }) => {
    return (
        <Helmet>
            {links.map((link) => (
                <link
                    key={link.hreflang}
                    rel="alternate"
                    hreflang={link.hreflang}
                    href={link.href}
                />
            ))}
        </Helmet>
    );
};

export default HreflangTags;
